import {
  CostCentreArrayInputComponent,
  GenericCurrencyInputComponent,
  GenericDateIsoStringInputComponent,
  GenericDisabledTextInputComponent,
  SelectTruckIdInputComponent,
} from "./InputComponents";

export const rateDefinition = {
  id: {
    displayName: "ID",
    displayValue: (entity) => String(entity.id),
    inputComponent: GenericDisabledTextInputComponent,
    isValid: (entity) => true,
  },

  truckId: {
    displayName: "Truck",
    displayValue: (entity) => String(entity.truckId),
    inputComponent: SelectTruckIdInputComponent,
    isValid: (entity) => entity.truckId !== undefined,
  },
  floatingRate: {
    displayName: "Floating Rate",
    displayValue: (entity) =>
      entity.floatingRate
        ? `$${(Math.round(entity.floatingRate * 100) / 100).toFixed(2)}`
        : "",
    inputComponent: GenericCurrencyInputComponent,
    isValid: (entity) =>
      Boolean(!entity.floatingRate) ||
      /^\d+(\.\d{1,6})?$/.test(String(entity.floatingRate)),
  },

  baseFee: {
    displayName: "Base Fee",
    displayValue: (entity) =>
      entity.baseFee
        ? `$${(Math.round(entity.baseFee * 100) / 100).toFixed(2)}`
        : "",
    inputComponent: GenericCurrencyInputComponent,
    // isValid: (entity) => /^\d+(\.\d{1,6})?$/.test(String(entity.baseFee)),
    isValid: (entity) => {
      if (entity.baseFee && entity.topup) return false;
      else if (!entity.baseFee) return true;
      else return /^\d{0,6}(\.\d{1,6})?$/.test(String(entity.baseFee));
    },
  },

  topup: {
    displayName: "Topup",
    displayValue: (entity) =>
      entity.topup
        ? `$${(Math.round(entity.topup * 100) / 100).toFixed(2)}`
        : "",
    inputComponent: GenericCurrencyInputComponent,
    isValid: (entity) => {
      if (entity.baseFee && entity.topup) return false;
      else if (!entity.topup) return true;
      else return /^\d{0,6}(\.\d{1,6})?$/.test(String(entity.topup));
    },
  },

  startDate: {
    displayName: "Start Date",
    displayValue: (entity) =>
      entity.startDate ? entity.startDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },

  endDate: {
    displayName: "End Date",
    displayValue: (entity) =>
      entity.endDate ? entity.endDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },

  ccArr: {
    displayName: "Cost Centres",
    displayValue: (entity) => "display function not implemented",
    inputComponent: CostCentreArrayInputComponent,
    isValid: (entity) => {
      console.log(entity.ccArr);
      // const notEmpty = entity.ccArr.length > 0;
      const percentSum = Number(
        Number(
          entity.ccArr.reduce((acc, cur) => acc + (cur.percentage || 0), 0)
        ).toFixed(4)
      );
      const percentSumTo100 = percentSum === 1;
      const allBranchSelected = !entity.ccArr.some((cc) => cc.shortCode === "");
      const allCcSelected = !entity.ccArr.some((cc) => cc.isParcel === "");
      // console.log("notEmpty", notEmpty);
      console.log("percentSumTo100", percentSumTo100);
      console.log(
        "neither basefee nor topup",
        !(entity.baseFee || entity.topup)
      );
      console.log("allCcSelected", allCcSelected);
      console.log("allBranchSelected", allBranchSelected);
      return (
        // notEmpty &&
        (percentSumTo100 || !(entity.baseFee || entity.topup)) &&
        allCcSelected &&
        allBranchSelected
      );
    },
  },
};

export const columns = [
  "id",
  "truckId",
  "floatingRate",
  "baseFee",
  "topup",
  "ccArr",
  "startDate",
  "endDate",
];

export const defaultRate = {
  id: 0,
  truckId: undefined,
  floatingRate: undefined,
  baseFee: undefined,
  topup: undefined,
  startDate: undefined,
  endDate: undefined,
  ccArr: [
    {
      id: "0",
      shortCode: "",
      isParcel: "",
      percentage: 0,
      costCentre: "",
    },
  ],
};

/*

|a     |b     |a or b     |not (a or b)
|------|------|-----------|------------
|0     |0     |0          |1
|0     |1     |1          |0
|1     |0     |1          |0
|1     |1     |1          |0

|a     |b     |not a     |not b     |(not a) and (not b)
|------|------|----------|----------|-------------------
|0     |0     |1         |1         |1
|0     |1     |1         |0         |0
|1     |0     |0         |1         |0
|1     |1     |0         |0         |0

*/
